
// import React, { useMemo, useState } from "react";
// import { Star, Plus, ArrowUpRight, Heart } from "lucide-react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { useSiteConfig } from "../../context/SiteConfigContext";
// import { useCart } from "../../context/CartContext";
// import { showError } from "../../utils/toastUtils";
// import Auth from "../../utils/AuthUtils";
// import wishlistAPI from "../../api/wishlistApi";

// const Card = ({ item }) => {
//   const navigate = useNavigate();
//   const { addToCart } = useCart();
//   const { config } = useSiteConfig();

//   // Dynamic price & variant calculations from your second component
//   const initialPrice =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.price ?? 0)
//       : (item?.price ?? item?.productPrice ?? 0);

//   const initialMrp =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.mrp ?? 0)
//       : (item?.mrp ?? 0);

//   const initialDiscount =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.discount ?? 0)
//       : (item?.discount ?? 0);

//   const initialStock =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.stock ?? 0)
//       : (item?.stock ?? 0);

//   const [activePrice] = useState(initialPrice);
//   const [activeMrp] = useState(initialMrp);
//   const [activeDiscount] = useState(initialDiscount);
//   const [activeStock] = useState(initialStock);
//   const [activeVariantId] = useState(
//     item?.productType === "Variant" && item?.variants?.length
//       ? item?.variants[0]._id
//       : null
//   );
//   const [isWishlisted, setIsWishlisted] = useState(item?.isWishlisted || false);

//   const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(Boolean);
//   const primaryImage = useMemo(
//     () => galleryImages[0] || item?.thumbnail || item?.productImage,
//     [galleryImages, item?.thumbnail, item?.productImage]
//   );
//   const hoverImage = useMemo(
//     () => galleryImages[1] || galleryImages[0] || primaryImage,
//     [galleryImages, primaryImage]
//   );

//   const hasDiscount = activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;
//   const isOutOfStock = activeStock <= 0;

//   const handleAddToCart = (e) => {
//     e.stopPropagation();
//     try {
//       addToCart(item?._id || item?.id, 1, activeVariantId || "");
//     } catch (err) {
//       console.error("Add to cart error:", err);
//     }
//   };

//   const handleWishlistToggle = async (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     const isLoggedIn = Auth.getToken();
//     if (!isLoggedIn) {
//       showError("Please log in to manage your wishlist");
//       return;
//     }

//     try {
//       const res = await wishlistAPI.addProduct({ productId: item?._id || item?.id });
//       if (res?.code === 200 || res?.success) {
//         setIsWishlisted((prev) => !prev);
//       }
//     } catch (error) {
//       showError("Failed to update wishlist");
//     }
//   };

//   const getTheme = (type) => {
//     switch (type) {
//       case "red": return "bg-rose-500/30";
//       case "green": return "bg-emerald-500/30";
//       case "gold": return "bg-amber-500/30";
//       default: return "bg-orange-500/30";
//     }
//   };

//   const glowColor = getTheme(item?.type || "gold");
//   const displayTitle = item?.title || item?.productName;
//   const displayVintage = item?.vintage || "2024";
//   const displayRating = item?.productRating || item?.rating || "4.9";
//   const displayRegion = item?.region || item?.shortDescription || "Organic Blend";

//   return (
//     <motion.div
//       layout
//       initial={{ opacity: 0, scale: 0.95 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.95 }}
//       transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
//       onClick={() => navigate(`/shop/${item?.slug || item?.productId || item?.id}`)}
//       className="group relative w-full cursor-pointer h-full min-h-[450px] flex flex-col justify-between"
//     >
//       {/* --- 1. VISUAL FRAME (Top) --- */}
//       <div className="relative w-full aspect-[4/5] bg-[var(--bg-light-panel)] rounded-[2rem] overflow-hidden isolate transition-colors duration-500 group-hover:bg-[var(--accent-cream,#f6f1e9)] border border-transparent group-hover:border-[var(--card-border)]">

//         {/* Ethereal Aura */}
//         <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 rounded-full blur-[80px] ${glowColor} opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-out group-hover:scale-150`} />

//         {/* Discount Badge */}
//         {hasDiscount && (
//           <div className="absolute top-6 left-6 z-30 bg-[var(--color-primary)] text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
//             {Math.round(activeDiscount)}% OFF
//           </div>
//         )}

//         {/* Vertical Vintage Label */}
//         {!hasDiscount && (
//           <div className="absolute top-6 left-6 z-20">
//             <span
//               className="block [writing-mode:vertical-rl] rotate-180 uppercase tracking-[0.25em]"
//               style={{
//                 fontFamily: "var(--font-subheading)",
//                 fontSize: "0.6rem",
//                 fontWeight: 600,
//                 color: "var(--color-text-muted)",
//                 transition: "color 0.4s ease",
//               }}
//             >
//               Est. {displayVintage}
//             </span>
//           </div>
//         )}

//         {/* Wishlist Icon */}
//         <div 
//           onClick={handleWishlistToggle}
//           className={`absolute top-6 right-16 z-30 w-8 h-8 rounded-full bg-white/80 backdrop-blur-md flex items-center justify-center transition-all duration-300 ${isWishlisted ? "text-rose-500" : "text-gray-600 hover:text-rose-500"}`}
//         >
//           <Heart size={16} fill={isWishlisted ? "currentColor" : "none"} />
//         </div>

//         {/* Rating */}
//         <div className="absolute top-6 right-6 z-20 flex flex-col items-center gap-1 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
//           <Star size={10} className="fill-[var(--color-accent-gold)] text-[var(--color-accent-gold)]" />
//           <span style={{ fontFamily: "var(--font-heading)", fontSize: "0.75rem", fontWeight: 600, color: "var(--color-text-secondary)" }}>
//             {displayRating}
//           </span>
//         </div>

//         {/* Product Images (Primary & Hover) */}
//         <div className="absolute inset-0 flex items-center justify-center z-10">
//           <img
//             src={primaryImage}
//             alt={displayTitle}
//             className="w-full h-full object-cover transition-all duration-700 ease-[cubic-bezier(0.33,1,0.68,1)] group-hover:scale-110 group-hover:-translate-y-2 grayscale-[0.3] group-hover:grayscale-0"
//           />
//         </div>

//         {/* Add Button */}
//         {!isOutOfStock && (
//           <div className="absolute bottom-6 right-6 z-30">
//             <button
//               onClick={handleAddToCart}
//               className="w-10 h-10 rounded-full flex items-center justify-center shadow-sm transition-all duration-300 group-hover:scale-110 hover:!scale-125"
//               style={{
//                 background: "#fff",
//                 border: "1px solid var(--card-border)",
//                 color: "var(--color-text-primary)",
//               }}
//               onMouseEnter={e => {
//                 e.currentTarget.style.background = "var(--color-primary)";
//                 e.currentTarget.style.borderColor = "var(--color-primary)";
//                 e.currentTarget.style.color = "#fff";
//               }}
//               onMouseLeave={e => {
//                 e.currentTarget.style.background = "#fff";
//                 e.currentTarget.style.borderColor = "var(--card-border)";
//                 e.currentTarget.style.color = "var(--color-text-primary)";
//               }}
//             >
//               <Plus size={18} />
//             </button>
//           </div>
//         )}
//       </div>

//       {/* --- 2. MINIMAL DETAILS (Bottom) --- */}
//       <div className="pt-4 px-2 flex flex-col gap-1">
//         <div className="flex justify-between items-baseline">
//           <h3
//             className="leading-none transition-colors duration-300 truncate pr-2"
//             style={{
//               fontFamily: "var(--font-logo)",
//               fontSize: "1.35rem",
//               color: "var(--color-text-primary)",
//               letterSpacing: "-0.01em",
//             }}
//           >
//             {displayTitle}
//           </h3>
//           <div className="flex items-center gap-2">
//             <span style={{ fontFamily: "var(--font-heading)", fontSize: "1rem", fontWeight: 600, color: "var(--color-text-primary)" }}>
//               ₹{activePrice}
//             </span>
//             {Number(activeMrp) > Number(activePrice) && (
//               <span className="line-through text-xs text-gray-400">
//                 ₹{activeMrp}
//               </span>
//             )}
//           </div>
//         </div>

//         <div className="flex items-center justify-between">
//           <p 
//             style={{ fontFamily: "var(--font-subheading)", fontSize: "0.58rem", fontWeight: 600, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--color-text-muted)" }}
//             className="group-hover:text-[var(--color-text-secondary)] transition-colors duration-300 truncate"
//           >
//             {displayRegion}
//           </p>

//           <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-all duration-500 -translate-x-2 group-hover:translate-x-0">
//             <span style={{ fontFamily: "var(--font-subheading)", fontSize: "0.58rem", fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--color-primary)" }}>
//               View
//             </span>
//             <ArrowUpRight size={10} style={{ color: "var(--color-primary)" }} />
//           </div>
//         </div>

//         {isOutOfStock && (
//           <p className="text-rose-500 text-xs font-bold mt-1">Out of Stock</p>
//         )}
//       </div>
//     </motion.div>
//   );
// };

// export default Card;






























// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { ArrowRight } from "lucide-react";
// import ProductsAPI from "../../../api/ProductsAPI";
// import Card from "../../../components/Card"; // Using your dynamic Card component

// const NewArrivals = () => {
//   const [products, setProducts] = useState([]);

//   useEffect(() => {
//     let fetchData = async () => {
//       try {
//         let res = await ProductsAPI.getAll();
//         setProducts(res.data || res);
//       } catch (e) {
//         // Fallback/Mock data structure matching Wine template / juice theme
//         setProducts([
//           {
//             id: 1,
//             productId: 1,
//             title: "Sunrise Citrus",
//             type: "white",
//             vintage: "2024",
//             productRating: "4.9",
//             thumbnail: "./assets/hero_img/hero_img_01.jpg",
//             region: "Valencia",
//             price: 450,
//           },
//           {
//             id: 2,
//             productId: 2,
//             title: "Green Detox",
//             type: "red",
//             vintage: "2024",
//             productRating: "4.8",
//             thumbnail: "./assets/hero_img/hero_img_02.jpg",
//             region: "Local Organic",
//             price: 550,
//           },
//           {
//             id: 3,
//             productId: 3,
//             title: "Ruby Beet",
//             type: "red",
//             vintage: "2023",
//             productRating: "4.6",
//             thumbnail: "./assets/hero_img/hero_img_03.jpg",
//             region: "Roots Farm",
//             price: 400,
//           },
//           {
//             id: 4,
//             productId: 4,
//             title: "Golden Ginger",
//             type: "sparkling",
//             vintage: "2024",
//             productRating: "5.0",
//             thumbnail: "./assets/hero_img/hero_img_04.jpg",
//             region: "Himalayas",
//             price: 350,
//           },
//         ]);
//       }
//     };
//     fetchData();
//   }, []);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400..900;1,6..96,400..900&family=Marcellus&family=Nunito:wght@400;600;700;900&display=swap');
        
//         :root {
//           --font-logo: "Bodoni Moda", serif;
//           --font-heading: "Marcellus", serif;
//           --font-body: "Nunito", sans-serif;
          
//           --color-primary: #d35400;
//           --color-primary-dark: #a84300;
//           --color-primary-light: #ff7f32;
//           --color-primary-lighter: #ffc49e;
          
//           --color-secondary: #6ba368;
//           --color-secondary-dark: #4f7c4d;
//           --color-secondary-lighter: #dff3d8;
          
//           --color-text-primary: #1a1a1a;
//           --color-text-muted: #8c8c8c;
//           --card-border: #eaeaea;
//           --bg-secondary: #f9f7f4;
//         }

//         .writing-vertical {
//            writing-mode: vertical-rl;
//            text-orientation: mixed;
//         }
//       `}</style>

//       <section className="relative py-24 bg-[var(--bg-secondary)] overflow-hidden min-h-screen">
//         {/* --- DECORATIVE BACKGROUND LINES --- */}
//         <div className="absolute inset-0 pointer-events-none z-0 flex justify-around opacity-[0.03]">
//           <div className="w-[1px] h-full bg-black"></div>
//           <div className="w-[1px] h-full bg-black"></div>
//           <div className="w-[1px] h-full bg-black"></div>
//           <div className="w-[1px] h-full bg-black"></div>
//           <div className="w-[1px] h-full bg-black hidden md:block"></div>
//         </div>

//         <div className="container mx-auto px-6 relative z-10">
//           {/* --- HEADER --- */}
//           <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8">
//             <div className="max-w-2xl">
//               <motion.span
//                 initial={{ opacity: 0, x: -20 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 className="block font-['Nunito'] text-xs font-bold uppercase tracking-[0.3em] text-[var(--color-primary)] mb-4"
//               >
//                 Curated Selection
//               </motion.span>
//               <motion.h2
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.1 }}
//                 className="font-['Bodoni_Moda'] text-5xl md:text-7xl text-[var(--color-text-primary)] leading-[1.1]"
//               >
//                 The Harvest <br />{" "}
//                 <span className="italic text-[var(--color-secondary-dark)]">
//                   Gallery
//                 </span>
//               </motion.h2>
//             </div>

//             <div className="flex items-center gap-4">
//               <button className="group flex items-center gap-3 px-6 py-3 rounded-full border border-[var(--color-text-primary)] hover:bg-[var(--color-text-primary)] hover:text-white transition-all duration-300">
//                 <span className="font-['Nunito'] text-xs font-bold uppercase tracking-widest">
//                   View All
//                 </span>
//                 <ArrowRight
//                   size={16}
//                   className="group-hover:translate-x-1 transition-transform"
//                 />
//               </button>
//             </div>
//           </div>

//           {/* --- STAGGERED GRID LAYOUT --- */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {products.slice(0, 4).map((item, index) => (
//               <motion.div
//                 key={item._id || item.id || index}
//                 // Stagger Effect: Even items start normal, Odd items are pushed down on desktop
//                 className={`${
//                   index % 2 !== 0 ? "lg:mt-24" : "lg:mt-0"
//                 } flex justify-center`}
//                 initial={{ opacity: 0, y: 50 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true, margin: "-50px" }}
//                 transition={{
//                   delay: index * 0.2,
//                   duration: 0.8,
//                   ease: "easeOut",
//                 }}
//               >
//                 <Card item={item} />
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default NewArrivals;







import React, { useEffect, useState } from "react";
import { Heart, ShoppingBag, Leaf, Star, ArrowRight, Plus } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";
import { hover } from "framer-motion";

const TopSellingCard = ({ item }) => {
    const { addToCart } = useCart();
    const navigate = useNavigate();
    const { config } = useSiteConfig();
    const initialPrice =
        item?.productType === "Variant"
            ? (item?.variants?.[0]?.price ?? 0)
            : (item?.price ?? 0);

    const initialMrp =
        item?.productType === "Variant"
            ? (item?.variants?.[0]?.mrp ?? 0)
            : (item?.mrp ?? 0);

    const initialDiscount =
        item?.productType === "Variant"
            ? (item?.variants?.[0]?.discount ?? 0)
            : (item?.discount ?? 0);

    const initialStock =
        item?.productType === "Variant"
            ? (item?.variants?.[0]?.stock ?? 0)
            : (item?.stock ?? 0);
    const [image, setImage] = useState(item?.thumbnail);
    const [slug, setSlug] = useState(item?.slug);
    const [title, setTitle] = useState(item?.title);
    const [activePrice, setActivePrice] = useState(initialPrice);
    const [activeMrp, setActiveMrp] = useState(initialMrp);
    const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
    const [activeStock, setActiveStock] = useState(initialStock);
    const [activeVariantId, setActiveVariantId] = useState(
        item?.productType === "Variant" && item?.variants?.length
            ? item?.variants[0]._id
            : null,
    );
    const [isWishlisted, setIsWishlisted] = useState(item?.isWishlisted || false);
    const isLoggedIn = Auth.getToken();

    useEffect(() => {
        if (item?.productType !== "Variant") return;
        const selected = item?.variants?.find((v) => v._id === activeVariantId);
        if (selected) {
            const newImg = selected.images?.[0] || item?.thumbnail;
            setImage(newImg);
            setActivePrice(selected.price);
            setActiveMrp(selected.mrp);
            setActiveDiscount(selected.discount);
            setActiveStock(selected.stock);
        }
    }, [activeVariantId, item]);

    const handleAddToCart = (e) => {
        const action = e.currentTarget.getAttribute("data-action");
        try {
            addToCart(item?._id, 1, activeVariantId || "");
            if (action === "buy-now") {
                navigate("/checkout");
            }
        } catch (err) {
            console.error("Add to cart error:", err);
        }
    };

    const handleWishlistToggle = async (e) => {
        e.preventDefault();
        const isLoggedIn = Auth.getToken();
        if (!isLoggedIn) {
            showError("Please log in to manage your wishlist");
            return;
        }
        try {
            const res = await wishlistAPI.addProduct({
                productId: item?._id,
            });
            if (res.code === 200) {
                setIsWishlisted((prev) => !prev);
            }
        } catch (error) {
            showError("Failed to update wishlist");
        }
    };

    console.log(config?.productVisibility);

    return (
        <div className="group relative w-full max-w-[340px] h-[500px] cursor-pointer perspective-1000">
            {/* CARD BASE CONTAINER */}
            <div className="relative w-full h-full bg-white rounded-[1rem] shadow-sm group-hover:shadow-2xl transition-all duration-700 ease-[cubic-bezier(0.23,1,0.32,1)] overflow-hidden border border-[var(--card-border)] group-hover:border-[var(--color-primary-lighter)]">
                {/* --- LAYER 2: DECORATIVE BADGES --- */}
                <div className="absolute top-6 left-6 z-20 flex flex-col items-start gap-2">
                    <span className="font-['Nunito'] text-[10px] font-bold uppercase tracking-widest text-[var(--color-text-muted)] bg-[var(--bg-secondary)] px-2 py-1 rounded-sm">
                        {item.availableSizes}
                    </span>
                </div>

                <div className="absolute top-2 right-2 z-20">
                    <button
                        onClick={handleWishlistToggle}
                        className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-[var(--color-primary)] hover:border-[var(--color-card-border)] transition-all duration-300"
                    >
                        <Heart
                            size={18}
                            className={`${isWishlisted
                                ? "fill-[var(--color-primary)] text-[var(--color-primary)]"
                                : "text-[var(--color-primary)]"
                                } transition-colors`}
                        />
                    </button>
                </div>

                {/* --- LAYER 3: THE PRODUCT (Floating Depth) --- */}
                <div className="absolute inset-0 flex items-center justify-center z-10 pb-16">
                    <div className="relative w-full h-full transition-transform duration-700 ease-out group-hover:-translate-y-6 group-hover:scale-105">
                        <img
                            src={item.thumbnail}
                            alt={item.title}
                            className="w-full h-full object-cover drop-shadow-[0_10px_20px_rgba(0,0,0,0.1)] group-hover:drop-shadow-[0_20px_30px_rgba(211,84,0,0.25)] transition-all duration-500"
                        />

                        {/* Organic Tag - Floats next to bottle */}
                        <div className="absolute -bottom-4 -right-4 bg-white/90 backdrop-blur-sm shadow-md px-3 py-1.5 rounded-full flex items-center gap-1.5 opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-100">
                            <Leaf size={10} className="text-[var(--color-secondary)]" />
                            <span className="text-[9px] font-bold font-['Nunito'] uppercase tracking-wider text-[var(--color-secondary-dark)]">
                                100% Bio
                            </span>
                        </div>
                    </div>
                </div>

                {/* --- LAYER 4: VERTICAL PRICE (Side Seal) --- */}
                <div className="absolute bottom-32 right-0 z-20 hidden md:flex items-center justify-center w-12 h-auto py-4 bg-white/50 backdrop-blur-sm border-l border-t border-b border-[var(--card-border)] rounded-l-xl opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                    <span
                        className="writing-vertical font-['Marcellus'] font-bold text-lg text-[var(--color-text-primary)] tracking-widest rotate-180"
                        style={{ writingMode: "vertical-rl" }}
                    >
                        ₹{item.price}
                    </span>
                </div>

                {/* --- LAYER 5: INFO PANEL (Slide Up Glass) --- */}
                <div className="absolute bottom-0 left-0 w-full z-30 bg-white border-t border-[var(--card-border)] transform translate-y-[80px] group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.19,1,0.22,1)]">
                    {/* Visible Part (Title) */}
                    <div className="px-6 py-3 bg-white relative z-10">
                        <div className="flex justify-between items-start">
                            <div className="flex flex-col">
                                <span className="text-[10px] text-[var(--color-primary)] font-bold uppercase tracking-wider mb-1 font-['Nunito']">
                                    {item.category || "Premium Collection"}
                                </span>
                                <h3 className="font-['Marcellus'] text-xl text-[var(--color-text-primary)] leading-none mb-1">
                                    {item.title}
                                </h3>
                                <div className="flex items-center gap-1 mt-1 md:hidden">
                                    <span className="font-['Marcellus'] font-bold text-[var(--color-primary)]">
                                        ₹{item.mrp}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Hidden Part (Action Buttons) */}
                    <div className="px-6 pb-6 pt-0 bg-white">
                        <div className="w-full h-[1px] bg-[var(--card-border)] mb-3"></div>

                        <div className="flex justify-between items-center">
  <button
    onClick={handleAddToCart}
     data-action="cart"
            data-bs-toggle="offcanvas"
            data-bs-target="#shoppingCartCanvas"
    className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-[var(--color-primary)]  text-white  transition-all duration-300"
  >
    <span className="text-[10px] font-bold uppercase tracking-widest font-['Nunito']">
      Add to Cart
    </span>
    <Plus size={14} />
  </button>
</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopSellingCard;
